import { TaskTypes } from '@sigmasms/shared-types'

import { services } from '@/utils'

import sticker from '@/components/sticker'

export default function(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value.title,
        label: this.getTranslate(`${services.tasks}.labels.title`),
        copy: true,
        borderStyle: this.to ? 'solid' : 'dashed',
        readonly: this.value.type !== TaskTypes['payments:recurrent'],
        to: this.to
      }
    }
  )
}
